var map = {
	"./Amit.jpeg": 4984,
	"./Amit2.jpeg": 7789,
	"./Cory copy.jpeg": 2723,
	"./Cory.jpeg": 2208,
	"./Daria.jpeg": 2271,
	"./Ruwan.jpeg": 6516,
	"./Sebastian.jpg": 5119,
	"./Sebastian2.jpg": 4397,
	"./Title.png": 8467,
	"./iswc-logo-light2.png": 3953,
	"./kep.png": 443,
	"./logo.png": 6949,
	"./logo.svg": 9574,
	"./road_signs.png": 8664
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;